import styled from 'styled-components';

export const AlarmTagAndText = styled.div`
    display: flex;
    gap: 0.25rem;
    align-items: center;
`;
